import FileSize from "../../../../components/commonComponent/FileSize";
import React, { useState } from "react";
import { PdfBadge, PdfPreviewModal } from "./PdfDocumentTable";
import serviceRulesPdf from "../../../../assets/rti_pdf/RuleBookCompendiumwithoutpdf-c4ec5c612724c86ae2a78f34e9bcbf25.pdf";
import recruitmentRulesPdf from "../../../../assets/rti_pdf/RecruitmentRulesPDF-36b79fd0d26433a7b7dfc35585171d5b.pdf";
import tadaRulesPdf from "../../../../assets/rti_pdf/TADARulesPDF-d24af052e82fd169f705c8854a670b50.pdf";
import amendedRulesPdf from "../../../../assets/rti_pdf/amendedRulesPDF-127657efc987da1d73c9313d8179eac2.pdf";
import transferOrdersPdf from "../../../../assets/rti_pdf/Chapter-4transfer-orders-and-work-allocationpdf-f2a4c4438b42534621eb8e4b3ccb5015.pdf";

const chapterFourDocuments = [
  {
    label: "Links of Service Rules:",
    title: "Links of Service Rules",
    fileName: "RuleBookCompendiumwithoutpdf-c4ec5c612724c86ae2a78f34e9bcbf25.pdf",
    href: serviceRulesPdf,
  },
  {
    label: "Recruitment Rules:",
    title: "Recruitment Rules",
    fileName: "RecruitmentRulesPDF-36b79fd0d26433a7b7dfc35585171d5b.pdf",
    href: recruitmentRulesPdf,
  },
  {
    label: "TA/DA Rules:",
    title: "TA/DA Rules",
    fileName: "TADARulesPDF-d24af052e82fd169f705c8854a670b50.pdf",
    href: tadaRulesPdf,
  },
  {
    label: "Amended Provisions:",
    title: "Amended Provisions",
    fileName: "amendedRulesPDF-127657efc987da1d73c9313d8179eac2.pdf",
    href: amendedRulesPdf,
  },
  {
    label: "Transfer Orders & Work Allocations:",
    title: "Transfer Orders & Work Allocations",
    fileName:
      "Chapter-4transfer-orders-and-work-allocationpdf-f2a4c4438b42534621eb8e4b3ccb5015.pdf",
    href: transferOrdersPdf,
  },
];

const ChapterFourContent = () => {
  const [selectedDocument, setSelectedDocument] = useState(null);

  return (
    <>
      <article className="min-w-0 flex-1 px-1 pb-8 font-sans text-[14px] leading-7 text-[#123764]">
        <h2 className="mb-3 max-w-[970px] text-[20px] font-bold leading-7 text-[#006461]">
          Chapter 4 : Rules, Regulations, Instruction Manuals and records for
          discharging functions [SECTION 4(1)(B)(v)]
        </h2>

        <p>
          Rules, Regulations, Instructions, Manual and Records for Discharging
          Functions.
        </p>

        <ul className="mb-3 ml-6 list-disc space-y-1">
          <li>Compendium of Service Rules</li>
          <li>
            Govt. orders/notifications received from time to time with regard to
            revision of salary, pay fixation, DA, reservation and recruitment
            related matters
          </li>
        </ul>

        <div className="overflow-x-auto rounded-lg border border-[#d9e4ef] bg-white">
          <table className="w-full min-w-[600px] border-collapse text-left text-[14px] leading-6">
            <caption className="sr-only">Chapter 4 rules and instruction documents</caption>
            <thead>
              <tr className="bg-[#dce9fb] text-[#123764]">
                <th scope="col" className="w-[72px] border-b border-[#d9e4ef] px-4 py-3">S.No.</th>
                <th scope="col" className="border-b border-[#d9e4ef] px-4 py-3">Title</th>
                <th scope="col" className="w-[260px] border-b border-[#d9e4ef] px-4 py-3">File</th>
              </tr>
            </thead>
            <tbody>
              {chapterFourDocuments.map((document, index) => (
                <tr key={document.fileName} className={index % 2 === 0 ? "bg-[#fbfdff]" : "bg-[#f5f9fc]"}>
                  <td className="border-b border-r border-[#d9e4ef] px-4 py-3 align-top font-medium">{index + 1}</td>
                  <th scope="row" className="border-b border-[#d9e4ef] px-4 py-3 align-top font-normal">{document.title}</th>
                  <td className="border-b border-[#d9e4ef] px-4 py-3 align-top">
                    <button
                      type="button"
                      onClick={() => setSelectedDocument(document)}
                      aria-label={`Open ${document.title}`}
                      className="inline-flex flex-wrap items-center gap-2 bg-transparent p-0 text-[#123764] underline underline-offset-2 hover:text-[#0f8a7e] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#0f8a7e] focus-visible:ring-offset-2"
                    >
                      Click here to open
                      <PdfBadge /><FileSize href={document.href} fileName={document.fileName} />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </article>

      {selectedDocument && (
        <PdfPreviewModal
          pdfDocument={selectedDocument}
          onClose={() => setSelectedDocument(null)}
        />
      )}
    </>
  );
};

export default ChapterFourContent;
